import {message} from 'antd';
import {removeFirstAndLastQuotes} from '../../utils/helpers/helpers';

export const setTokens = (data) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_TOKENS',
      payload: data,
    });
  };
};

export const setIsAuthenticated = (data) => ({
  type: 'SET_IS_AUTHENTICATED',
  payload: data.isAuthenticated,
});

export const getAuthTokenStorage = () => {
  return async (dispatch) => {
    dispatch({
      type: 'LOCAL_STORAGE_TOKEN',
      payload: {splash: true},
    });
    const accessToken = await localStorage.getItem('accessToken');
    const accountType = await localStorage.getItem('accountType');
    const authToken = await localStorage.getItem('authToken');
    if (accessToken || accountType || authToken) {
      const auth = removeFirstAndLastQuotes(authToken);
      dispatch({
        type: 'LOCAL_STORAGE_TOKEN',
        payload: {
          splash: false,
          authToken: auth,
          accessToken: accessToken,
          accountType: accountType,
          apolloAuth: auth,
        },
      });
    } else {
      dispatch({
        type: 'LOCAL_STORAGE_TOKEN',
        payload: {
          splash: false,
          authToken: null,
          accessToken: null,
          accountType: null,
        },
      });
    }
  };
};

export const logoutApp = () => {
  return async (dispatch) => {
    try {
      await localStorage.clear();
      dispatch({type: 'LOGOUT'});
    } catch (e) {
      message.error(e);
    }
  };
};
